import { FC, useEffect, useState } from 'react';
import { Layout } from 'taxaroo-ui';
import { isMobileView } from '~src/components/helpers/screen';
import Menu from './Menu';

const { Sider } = Layout;

type LeftSideMenuProps = {
  stateChanged: (isCollapsed: boolean) => void;
}

const LeftSideMenu:FC<LeftSideMenuProps> = ({ stateChanged }) => {
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => stateChanged(collapsed), [collapsed]);

  return (
    <Sider
      className="site-layout-background"
      width={175}
      breakpoint="md"
      onBreakpoint={(broken) => {
        if (broken) {
          if (!collapsed) {
            setCollapsed(!collapsed);
          }
        }
      }}
      collapsed={collapsed}
      collapsible
      onCollapse={() => setCollapsed(!collapsed)}
    >
      <Menu
        onClick={
          isMobileView()
            ? () => setCollapsed(true)
            : undefined
        }
      />
    </Sider>
  );
};

export default LeftSideMenu;
